export default class Constants {
    // QUANTA (2026-10-22): pointed at the local stub server + local stub asset
    // folders (public/stub/) so the proof build runs fully offline. The upstream
    // defaults were wss://game.bobba.io/ and https://images.bobba.io/... —
    // restore those if you ever want the original live service.
    // REACT_APP_WS_URL overrides at build time: the live preview build sets
    // "local://stub" (in-page stub engine, no backend); local dev defaults to
    // the stub server on 8585.
    public static readonly WS_URL = (process.env as any).REACT_APP_WS_URL || "ws://127.0.0.1:8585/"

    public static readonly AVATAR_RESOURCES_URL = "/stub/avatar/";
    public static readonly FURNI_RESOURCES_URL = "/stub/furni/";
    public static readonly CATALOGUE_RESOURCES_URL = "/stub/catalogue/";
    public static readonly TOP_STORY_RESOURCES_URL = "/stub/topstory/";
    public static readonly BADGE_RESOURCES_URL = "/stub/badges/";
}
